import { SVGProps } from 'react'

export const RectRoundCheckbox4 = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="12.5" cy="12" r="11" fill="#FF7F6B" stroke="#FF7F6B" strokeWidth="2" />
      <path
        d="M19.2399 7.45179C18.8937 7.09995 18.3326 7.0994 17.9857 7.45015L10.5627 14.638L7.01537 11.0898C6.66855 10.738 6.10669 10.7382 5.76009 11.0904C5.4133 11.4427 5.4133 12.0141 5.76009 12.3665L5.76096 12.3674L9.93326 16.5487C10.2796 16.9001 10.8404 16.9004 11.1871 16.5497L19.2371 8.73078L19.2399 8.7279C19.5867 8.37551 19.5867 7.80418 19.2399 7.45179Z"
        fill="white"
      />
    </svg>
  )
}
